import { Input } from "@/app/admin/_common/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/app/admin/_common/ui/select";
import CuoButton from "@/app/admin/_common/CuoButton";
import { Can } from "@/app/admin/_common/Can";
import { PERMISSIONS } from "@/app/_utils/permissions";
import { Plus, Search } from "lucide-react";

export default function UsersToolbar({
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
  onInvite,
}: {
  search: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusChange: (value: string) => void;
  onInvite: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 pb-3">
      <div className="relative min-w-[200px] flex-1">
        <span className="pointer-events-none absolute inset-y-0 left-2.5 flex items-center">
          <Search className="size-3.5 text-muted-foreground" />
        </span>
        <Input
          className="pl-8"
          placeholder="Search by name or email"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div>

      <Select value={statusFilter} onValueChange={onStatusChange}>
        <SelectTrigger className="w-[150px]">
          <SelectValue placeholder="All statuses" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All statuses</SelectItem>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="pending">Invited</SelectItem>
          <SelectItem value="suspended">Suspended</SelectItem>
        </SelectContent>
      </Select>

      <Can permission={PERMISSIONS.RBAC_USERS_WRITE}>
        <CuoButton icon={<Plus className="size-4" />} onClick={onInvite} label="Invite user" />
      </Can>
    </div>
  );
}
